import { Injectable } from '@angular/core';
import { IQueryParams } from '@portal/shared/ui/table/src/lib/interfaces/query-params.interface';
import cloneDeep from 'lodash/cloneDeep';
import { DateFilterQuickPick } from '../../../shared/components/filter/date/enums/quick-pick.enum';

@Injectable({
  providedIn: 'root',
})
export class AuditLogPageStateService {
  dateFilterQuickPick = DateFilterQuickPick.Custom;
  toggleState = false;
  isInactiveVisible = false;
  private filter: IQueryParams;

  setFilter(filter: IQueryParams): void {
    this.filter = cloneDeep(filter);
  }

  getFilter(): IQueryParams {
    return cloneDeep(this.filter);
  }
}
